// ============================================================
// หน้า WaterUsageInfo — ข้อมูลการใช้น้ำ (รายการบิลที่จดไว้แล้ว)
// ------------------------------------------------------------
// สิ่งที่ทำได้ในหน้านี้
//   - ดูรายการบิลค่าน้ำทั้งหมด กรองตามบ้านเลขที่ แบ่งหน้า
//   - แก้ไขบิล (ไปหน้า /record-water-usage?id=...)
//   - ลบบิล — ลบได้เฉพาะใบที่ยังไม่มีการชำระเงินเข้ามาเลย (ดู canDelete)
//   - แก้ไขชื่อผู้ถือบิลหลายใบพร้อมกัน (ใช้ตอนเปลี่ยนเจ้าของห้อง)
// ============================================================

import React, { Component } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { loading, tokens, select_style, success, toFixed, GET, PUT, DELETE, format_date, alert, getStorage, permission, Paginate, ActionIcon, ICON } from "../../shared/index.js";

const perm = permission("record-water-usage");

// ฟิลด์ยอดที่ "ชำระแล้ว" ของแต่ละรายการ (ขึ้นต้นด้วย s_)
// ถ้ามีตัวใดตัวหนึ่งมีค่า แปลว่าบิลใบนี้ถูกชำระบางส่วน/ทั้งหมดแล้ว → ห้ามลบ
const PAID_FIELDS = [
  "s_add_debt",
  "s_cable_cost",
  "s_common_expenses",
  "s_equipment_maintenance_fee",
  "s_fire_cost",
  "s_late_payment",
  "s_meter_connect_cost",
  "s_other_income",
  "s_reduce_debt",
  "s_waste_cost",
  "s_water_bill",
];

// สถานะการชำระ 3 = ยกเลิก/ตัดหนี้แล้ว (ไม่ต้องเอามาให้แก้ชื่อ)
const STATUS_PAY_CANCELED = 3;

export default class WaterUsageInfo extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    this.state = {
      page: 1,
      filter_address_number: null,
      data: null, // รายการบิลของหน้าปัจจุบัน
      data_address: [], // ตัวเลือกบ้านเลขที่

      // popup แก้ไขชื่อผู้ถือบิล
      modal_update: false,
      search_room: null, // บ้านเลขที่ที่เลือกใน popup
      data_room: null, // บิลทั้งหมดของบ้านหลังนั้น
      data_fullname: [], // ตัวเลือกชื่อผู้ถือกรรมสิทธิ์ของบ้านหลังนั้น
      new_full_name: null, // ชื่อใหม่ที่จะเปลี่ยนไปใช้

      // ใช้ทำหัวคอลัมน์ "เลขมาตรเดือน..."
      month_current: today,
      month_last: new Date(today.getFullYear(), today.getMonth() - 1, today.getDate()),
    };
  }

  async componentDidMount() {
    if (!perm.view) return;
    loading(true);
    await Promise.all([this.GetAll(), this.GetAddressAll()]);
    loading(false);
  }

  pid = () => getStorage("project_id");

  // ---------- โหลดข้อมูล ----------

  // ตัวเลือกบ้านเลขที่ (แสดงเป็น "อาคาร x ห้อง y")
  GetAddressAll = async () => {
    const r = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${this.pid()}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (r?.status) {
      this.setState({ data_address: r.data.data.map((i) => ({ value: i.address_number, label: `อาคาร ${i.building} ห้อง ${i.address_number}` })) });
    }
  };

  // รายการบิลของหน้าปัจจุบัน
  GetAll = async () => {
    loading(true);
    const r = await GET(tokens, `v1/TH/record-water/filter-search/page/${this.state.page}/${this.pid()}`, { address_number: this.state.filter_address_number?.value || "" });
    if (r?.status) this.setState({ data: r.data });
    loading(false);
  };

  // บิลทั้งหมดของบ้านหลังที่เลือกใน popup (ตัดใบที่ยกเลิกแล้วออก)
  GetRoomAll = async () => {
    loading(true);
    const r = await GET(tokens, `v1/TH/record-water/filter-search/page/0/${this.pid()}`, { address_number: this.state.search_room?.value || "" });
    if (r?.status) this.setState({ data_room: { ...r.data, data: r.data.data?.filter((e) => e.status_pay !== STATUS_PAY_CANCELED) } });
    loading(false);
  };

  // รายชื่อผู้ถือกรรมสิทธิ์ของบ้านหลังที่เลือก (มีได้หลายคนถ้าเคยเปลี่ยนสัญญา)
  GetFullnameById = async () => {
    const r = await GET(tokens, `v1/TH/customer-manage/by-address/${this.pid()}`, { address_number: this.state.search_room?.value || "" });
    if (r?.status) {
      this.setState({ data_fullname: r.data.data.map((e) => ({ label: e.full_name, value: e.full_name, ref_customer_id: e.ref_customer_id })) });
    }
  };

  // ---------- แก้ไข / ลบ ----------

  // เปลี่ยนชื่อผู้ถือบิลของทุกใบที่ติ๊กเลือกไว้
  UpdateFullname = async () => {
    const { new_full_name, data_room, data_fullname } = this.state;
    if (!new_full_name) return alert("warning", "แจ้งเตือน", "กรุณาเลือกชื่อ-นามสกุลที่ต้องการเปลี่ยน");
    loading(true);

    const ref_customer_id = data_fullname?.find((e) => e.value === new_full_name.value)?.ref_customer_id || null;
    await Promise.all(
      data_room.data
        .filter((i) => i.selected)
        .map((i) => PUT(tokens, "v1/TH/record-water/update", { record_water_id: i.record_water_id, address_number: i.address_number || "", full_name: new_full_name.value || "", ref_customer_id }))
    );

    success();
    loading(false);
    this.setState({ modal_update: false }, this.GetAll);
  };

  Delete = async (id) => {
    loading(true);
    const r = await DELETE(tokens, `v1/TH/record-water/delete/${id}`, null);
    if (r?.status) {
      this.setState({ page: 1, filter_address_number: null });
      success();
      this.GetAll();
    }
    loading(false);
  };

  // ยืนยันก่อนลบ (ใช้ popup แบบเฉพาะของหน้านี้ ปุ่มยกเลิกสีแดง)
  confirmDelete = (item) => {
    Swal.fire({
      icon: "warning",
      title: "ยืนยันการลบข้อมูล",
      text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "ลบข้อมูล",
      cancelButtonText: "ยกเลิก",
    }).then((res) => {
      if (res.isConfirmed) this.Delete(item.record_water_id);
    });
  };

  // บิลใบนี้ลบได้ไหม — ลบได้เฉพาะใบที่ยังไม่มีการรับชำระเข้ามาเลย
  canDelete = (item) => !PAID_FIELDS.some((key) => item[key]);

  // ---------- ติ๊กเลือกใน popup ----------

  toggleAllRoom = (e) => this.setState((s) => ({ data_room: { ...s.data_room, data: s.data_room.data.map((i) => ({ ...i, selected: e.target.checked })) } }));

  toggleRoomItem = (index, checked) =>
    this.setState((s) => {
      const data = [...s.data_room.data];
      data[index].selected = checked;
      return { data_room: { ...s.data_room, data } };
    });

  // ---------- แสดงผล ----------

  // ช่องข้อมูลของ 1 แถว ใช้ร่วมกันทั้งตารางหลักและตารางใน popup
  // isModal = true จะมีคอลัมน์ชื่อ-นามสกุลเพิ่มมา
  renderRowData = (item, isModal) => {
    const money = (value) => (value ? toFixed(value) : "0.00");
    return (
      <>
        <td className="text-center">{item.address_number || "-"}</td>
        {isModal && <td className="text-center">{item.full_name || "-"}</td>}
        <td className="text-left">{item.datetime_create ? format_date(item.datetime_create) : "0"}</td>
        <td className="text-right">{item.current_gauge_number ? Number(item.current_gauge_number) : "0"}</td>
        <td className="text-right">{item.last_gauge_number ? Number(item.last_gauge_number) : "0"}</td>
        <td className="text-right">{money(item.unit_used)}</td>
        <td className="text-right">{money(item.water_bill)}</td>
        <td className="text-right">{money(item.equipment_maintenance_fee)}</td>
        <td className="text-right">{money(item.common_expenses)}</td>
        {/* "รายการอื่นๆ" = รายได้อื่น + ค่าเคเบิล รวมเป็นคอลัมน์เดียว */}
        <td className="text-right">{money((item.other_income || 0) + (item.cable_cost || 0))}</td>
        <td className="text-right">{money(item.total_amount)}</td>
      </>
    );
  };

  render() {
    const s = this.state;

    // หัวคอลัมน์ — ชื่อเดือนเปลี่ยนตามเดือนปัจจุบัน
    const headers = [
      "บ้านเลขที่",
      "วันที่บันทึก",
      `เลขมาตรเดือน${format_date(s.month_current, "MMM")}`,
      `เลขมาตรเดือน${format_date(s.month_last, "MMM")}`,
      "จำนวนหน่วยที่ใช้",
      "ค่าน้ำประปา",
      "ค่ารักษาอุปกรณ์น้ำ",
      "ค่าส่วนกลาง",
      "รายการอื่นๆ",
      "รวมเป็นเงิน",
    ];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลการใช้น้ำ" />

        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              {/* หัวข้อ + ปุ่ม */}
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3">
                  <b>
                    ข้อมูลการใช้น้ำประจำเดือน{format_date(new Date(), "MMMM")} พ.ศ. {format_date(new Date(), "YYYY")}
                  </b>
                </h4>
                <div className="d-flex row mx-0">
                  <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => this.setState({ modal_update: true, search_room: null, data_fullname: null, new_full_name: null, data_room: null })}>
                    แก้ไขรายชื่อบิลตามบ้านเลขที่
                  </button>
                  <button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => (window.location.href = "/record-water-usage")}>
                    ย้อนกลับ
                  </button>
                </div>
              </div>

              {/* ตัวกรอง */}
              {perm.view && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <div className="d-flex row mx-0">
                    <Select
                      className="form-control bg-contain border-0 select-search wpx-200 mb-3 mx-1"
                      styles={select_style}
                      options={s.data_address}
                      onChange={(e) => this.setState({ filter_address_number: e })}
                      value={s.filter_address_number}
                    />
                    <button className="btn btn-primary px-3 mb-3 mx-1" onClick={() => this.setState({ page: 1 }, this.GetAll)}>
                      ค้นหา
                    </button>
                    <button className="btn btn-outline-primary px-3 mb-3 mx-1" onClick={() => this.setState({ filter_address_number: null, page: 1 }, this.GetAll)}>
                      รีเซ็ท
                    </button>
                  </div>
                </div>
              )}

              {/* ตารางรายการบิล */}
              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {headers.map((h, i) => (
                        <th key={i} className={i === 1 ? "text-left" : "text-center"}>
                          {h}
                        </th>
                      ))}
                      {perm.update && <th className="text-center">จัดการ</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {!s.data?.data?.length ? (
                      <tr>
                        <td colSpan={11} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      s.data.data.map((item, index) => (
                        <tr key={index}>
                          {this.renderRowData(item, false)}
                          {perm.update && (
                            <td className="text-center">
                              <div className="d-flex justify-content-center">
                                <ActionIcon color="primary" icon={ICON.edit} title="แก้ไข" className="mr-2" onClick={() => (window.location.href = "/record-water-usage?id=" + item.record_water_id)} />
                                {/* ปุ่มลบโผล่เฉพาะบิลที่ยังไม่มีการรับชำระ */}
                                {this.canDelete(item) && <ActionIcon color="danger" icon={ICON.paper} title="ลบ" className="mr-2" onClick={() => this.confirmDelete(item)} />}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate data={s.data} page={s.page} onChange={(value) => this.setState({ page: value }, this.GetAll)} />
            </div>
          </div>
        </div>

        {/* popup แก้ไขชื่อผู้ถือบิลหลายใบพร้อมกัน */}
        <Modal show={s.modal_update} onHide={() => this.setState({ modal_update: false })} size="xl">
          <Modal.Header>
            <Modal.Title>
              <b>แก้ไขรายชื่อบิลตามบ้านเลขที่</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4 mb-2">
                <label>บ้านเลขที่</label>
                <Select
                  className="form-control bg-contain border-0 select-search w-100 mb-3 mx-1"
                  styles={select_style}
                  options={s.data_address || []}
                  value={s.search_room}
                  onChange={(e) =>
                    this.setState({ search_room: e }, () => {
                      this.GetRoomAll();
                      this.GetFullnameById();
                    })
                  }
                />
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-2">
                <label>ชื่อ-นามสกุลที่ต้องการเปลี่ยน</label>
                <Select className="form-control bg-contain border-0 w-100 select-search" styles={select_style} options={s.data_fullname || []} value={s.new_full_name} onChange={(e) => this.setState({ new_full_name: e })} />
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-borderless table-striped">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    {/* ติ๊กเลือกทั้งหมด */}
                    <th className="text-center">
                      <input type="checkbox" onChange={this.toggleAllRoom} checked={s.data_room?.data?.length > 0 && s.data_room.data.every((item) => item.selected)} />
                    </th>
                    {/* ตารางใน popup มีคอลัมน์ชื่อ-นามสกุลแทรกก่อนวันที่บันทึก */}
                    {headers.map((h, i) =>
                      i === 1 ? (
                        <React.Fragment key={i}>
                          <th className="text-center">ชื่อ-นามสกุล</th>
                          <th className="text-left">{h}</th>
                        </React.Fragment>
                      ) : (
                        <th key={i} className="text-center">
                          {h}
                        </th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                  {!s.data_room?.data?.length ? (
                    <tr>
                      <td colSpan={12} className="text-center">
                        ไม่มีข้อมูล
                      </td>
                    </tr>
                  ) : (
                    s.data_room.data.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <input type="checkbox" checked={item.selected || false} onChange={(e) => this.toggleRoomItem(index, e.target.checked)} />
                        </td>
                        {this.renderRowData(item, true)}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_update: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={this.UpdateFullname}>
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
